// Enumerations
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';
import { WebSocketPayloadStatusEnumeration } from 'enumerations/wbsocket-payload-status.enumeration';
// Types
import {
  KycBizumBuilderHandlersType,
  KycBizumMethodsHandlersType,
  KycBizumOnErrorBuilderHandlersType,
  KycBizumReceiveBuilderHandlersType,
  KycBizumResetBuilderHandlersType,
} from './types/kyc-bizum.handlers.type';
import { WsResponseType } from 'types/ws-response.type';

const manageReceivedDataFromKycWSEventHandler = ({
  message,
  setCurrentState,
  setError,
}: KycBizumReceiveBuilderHandlersType): void => {
  const response = JSON.parse(message as any);

  switch (response?.detail?.payload?.status) {
    case WebSocketPayloadStatusEnumeration.ACCEPTED:
      setCurrentState(AppStatesEnumeration.LOADING);
      break;
    case WebSocketPayloadStatusEnumeration.REJECTED:
    default:
      setError(true);
  }
};

const onErrorKycBizumWsMessageHandler = ({
  setError,
}: KycBizumOnErrorBuilderHandlersType): void => {
  setError(true);
};

const resetButtonOnEnterViewHandler = ({
  setMainButtonConfiguration,
}: KycBizumResetBuilderHandlersType): void => {
  setMainButtonConfiguration({});
};

const KycBizumHandlers = ({
  setCurrentState,
  setError,
  setMainButtonConfiguration,
}: KycBizumBuilderHandlersType): KycBizumMethodsHandlersType => ({
  handleOnErrorKycBizumWsMessage: () => onErrorKycBizumWsMessageHandler({ setError }),
  handleOnReceiveKycBizumWsMessage: (message: WsResponseType<WebSocketPayloadStatusEnumeration>) =>
    manageReceivedDataFromKycWSEventHandler({ message, setCurrentState, setError }),
  handleResetButtonOnEnterView: () => resetButtonOnEnterViewHandler({ setMainButtonConfiguration }),
});

export { KycBizumHandlers };
